

































import { Component, Prop, Vue } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
import { PlanSetting, IPlanSummaryData, BookingTypeEnum } from '@/api/types';

type HeaderType = {
  text: string;
  value: string;
};

@Component({
  name: 'PlanSettingListResult',
})
export default class extends Vue {
  @Prop({ required: true }) plans!: (PlanSetting & IPlanSummaryData)[];
  private headers: HeaderType[] = [];
  private loading = true;
  private filterText = '';

  mounted() {
    this.loadHeaders();
    this.loading = false;
  }

  private loadHeaders() {
    const productName: HeaderType = {
      text: this.$t('Activity name') as string,
      value: 'activityTitle',
    };
    const title: HeaderType = {
      text: this.$t('{msg} name', { msg: this.$t('Plan') }) as string,
      value: 'planTitle',
    };
    const bookingType: HeaderType = {
      text: this.$t('Booking type') as string,
      value: 'bookingType',
    };
    const operations: HeaderType = {
      text: this.$t('Operations') as string,
      value: 'operations',
    };
    const headers: HeaderType[] = [productName, title, bookingType, operations];
    this.headers = headers;
  }

  private getBookingTypeText(bookingType?: BookingTypeEnum) {
    return this.$t(
      `BookingTypeEnum.${bookingType || BookingTypeEnum.EACH_TIME}`
    );
  }

  private navigateWithPlan(plan: PlanSetting & IPlanSummaryData) {
    this.$router.push({
      name: 'plansetting-detail',
      params: {
        id: plan.id!,
      },
      query: {
        systemSource: plan.systemSource || undefined
      },
    });
  }
}
